import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import EnrolledBatchState from './EnrolledBatchState';
import UnEnrolledBatchState from './UnEnrolledBatchState';

const Wrapper = styled.div`
  grid-column: 17/25;
  grid-row: ${({ $rows }) => `1/${$rows}`};
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const BatchStateWrapper = styled.div`
  grid-column: 17/25;
  border-radius: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_12B};
  position: sticky;
  top: 10%;
  z-index: 3;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;
const BatchStateCard = ({ batchDetails, totalGridRows, entitySubType }) => {
  const { isEnrolled } = batchDetails;
  return (
    <Wrapper $rows={totalGridRows}>
      <BatchStateWrapper>
        {isEnrolled ? (
          <EnrolledBatchState
            batchDetails={batchDetails}
            entitySubType={entitySubType}
          />
        ) : (
          <UnEnrolledBatchState
            batchDetails={batchDetails}
            entitySubType={entitySubType}
          />
        )}
      </BatchStateWrapper>
    </Wrapper>
  );
};
export default BatchStateCard;
